import { 
    IMinCostPerSquareFootLookupController 
} from '../Interfaces/ControllerInterfacesBarrel';

import {
    MinCostPerSquareFootLookup,
    MinCostPerSquareFootWithId,
} from "@app/models/api";

export default class MockMinCostPerSquareFootLookupController implements IMinCostPerSquareFootLookupController {
    public constructor() {      
    }
    public async getAllMinCostPerSquareFootLookup(minCostPerSquareFootLookup: MinCostPerSquareFootLookup): Promise<MinCostPerSquareFootWithId[]> {
        throw new Error("Method not implemented.");
    }
}